import React from "react";

const RecordCell = ({ record }) => {
    if (!record) {
        return (
            <div className="grid min-w-0 grid-cols-[minmax(0,2fr)_minmax(0,.8fr)_minmax(0,1.2fr)] items-center gap-3 px-4 py-3">
                <span />
                <span className="text-center text-sm font-semibold text-text-muted">No record available.</span>
                <span />
            </div>
        );
    }
    return (
        <div className="grid min-w-0 grid-cols-[minmax(0,2fr)_minmax(0,.8fr)_minmax(0,1.2fr)] items-center gap-3 px-4 py-3">
            <span className="min-w-0 whitespace-normal text-xs font-extrabold uppercase tracking-wide text-text-muted">{record.label}</span>
            <span className="min-w-0 truncate text-center text-sm font-extrabold text-text">{record.owner}</span>
            <span className="min-w-0 justify-self-end whitespace-nowrap font-mono text-xs font-bold text-text-muted">{record.value}</span>
        </div>
    );
};

const SeasonRecordsPairTable = ({ bestStats, worstStats, loadingLabel }) => {
    if (!bestStats || !worstStats) {
        return <div className="rounded-lg border border-border bg-surface px-4 py-6 text-center text-sm font-semibold text-text-muted">Loading {loadingLabel}...</div>;
    }

    const rows = Array.from({ length: Math.max(bestStats.length, worstStats.length) }, (_, index) => [bestStats[index], worstStats[index]]);
    return (
        <div className="overflow-hidden rounded-lg border border-border-card bg-white shadow-sm">
            <div className="grid grid-cols-[1fr_1px_1fr] overflow-hidden rounded-t-lg bg-forest text-white">
                <div className="rounded-tl-lg px-4 py-3 text-xs font-extrabold uppercase tracking-widest">Most</div>
                <div className="bg-white/20" />
                <div className="rounded-tr-lg px-4 py-3 text-xs font-extrabold uppercase tracking-widest">Fewest</div>
            </div>
            {rows.map(([best, worst], index) => (
                <div key={index} className={`grid grid-cols-[1fr_1px_1fr] ${index % 2 ? "bg-surface" : "bg-white"}`}>
                    <RecordCell record={best} />
                    <div className="bg-border-card" />
                    <RecordCell record={worst} />
                </div>
            ))}
        </div>
    );
};

export default SeasonRecordsPairTable;
